import {
  cancelFlushSession,
  finalizeFlushSession,
  getActiveFlushSession,
  getFlushSession,
  scanFlushItem,
  startFlushSession,
} from "./schema/flush";

export const groupM: {
  cancelFlushSession: typeof cancelFlushSession;
  finalizeFlushSession: typeof finalizeFlushSession;
  getActiveFlushSession: typeof getActiveFlushSession;
  getFlushSession: typeof getFlushSession;
  scanFlushItem: typeof scanFlushItem;
  startFlushSession: typeof startFlushSession;
} = {
  cancelFlushSession,
  finalizeFlushSession,
  getActiveFlushSession,
  getFlushSession,
  scanFlushItem,
  startFlushSession,
};
